/**
 * ForgeViewerWrapper — thin React shell around useForgeViewer.
 * Renders the viewer container and a status pill in the corner.
 */
import { useEffect } from 'react';
import { useForgeViewer } from '@/hooks/useForgeViewer';
import { Loader2, AlertCircle, CheckCircle2 } from 'lucide-react';

export default function ForgeViewerWrapper({ projectId, urn, onReady, onCameraChange, height = 500, testId = 'forge-viewer' }) {
  const { containerRef, viewer, status, error } = useForgeViewer({
    projectId,
    urn,
    onCameraChange,
    onModelLoaded: onReady,
  });

  useEffect(() => {
    if (status === 'ready' && viewer && onReady) onReady(viewer);
  }, [status, viewer, onReady]);

  return (
    <div className="relative rounded-xl overflow-hidden" style={{ height, background: '#0a0e14', border: '1px solid #1f2937' }} data-testid={testId}>
      <div ref={containerRef} className="absolute inset-0" />
      <div className="absolute top-2 left-2 px-2 py-1 rounded-md text-[10px] uppercase tracking-wider flex items-center gap-1.5"
        style={{
          background: 'rgba(0,0,0,0.65)',
          color: status === 'ready' ? '#10b981' : status === 'error' ? '#ef4444' : '#fbbf24',
        }}>
        {status === 'loading' || status === 'model-loading' ? <Loader2 className="w-3 h-3 animate-spin" /> :
         status === 'ready' ? <CheckCircle2 className="w-3 h-3" /> :
         status === 'error' ? <AlertCircle className="w-3 h-3" /> : null}
        {status === 'ready' ? 'Viewer ready' :
         status === 'sdk-ready' ? 'No model loaded' :
         status === 'model-loading' ? 'Loading model…' :
         status === 'loading' ? 'Initializing…' :
         status === 'error' ? (error || 'Error') : status}
      </div>
    </div>
  );
}
